<div class="input-group {{ size && 'input-group-' + size }}">
  <input
    type="number"
    class="form-control"
    [min]="min || 0"
    [max]="max"
    [step]="step"
    [formControl]="control"
  />
  <span *ngIf="addonText" class="input-group-addon">{{ addonText }}</span>
</div>
